import React from "react";
import { IFounderMessageData } from "../../exports/interfaces";
import { Fade } from "react-awesome-reveal";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import { marked } from "marked";
import { useLoader } from "../../context/LoaderContext";

const FounderMessage = (props: {
  founderMessageData: IFounderMessageData[];
}) => {
  const mobile = useMobile();
  const tab = useTab();
  const { loading } = useLoader();
  return (
    <section className="about-page" style={{ padding: "0px 0px 74px 0px" }}>
      <div className="container">
        <div className="section-title custom-text-center">
          <span className="custom-fontweight">
            {props?.founderMessageData[0]?.primary_title}
          </span>
          <h2 className="section-title__title">
            {props?.founderMessageData[0]?.secondary_title}
          </h2>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div style={{ width: "100%", position: "relative" }}>
              <div
                className="about-page__img-wrapper"
                style={{
                  float: !mobile && !tab ? "left" : "unset",
                  width: !mobile && !tab ? "45%" : "100%",
                  marginRight: !mobile && !tab ? "50px" : "unset",
                  marginBottom: "1rem",
                }}
              >
                {!loading && (
                  <Fade
                    cascade
                    damping={0.2}
                    direction="left"
                    triggerOnce={true}
                  >
                    <div className="about-page__img">
                      <img
                        src={
                          props?.founderMessageData[0]?.image[0]?.media?.url &&
                          `${process.env.REACT_APP_cmsUrl}${props?.founderMessageData[0]?.image[0]?.media?.url}`
                        }
                        alt="about-image"
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "498px",
                        }}
                      />
                      <div
                        className="mt-2"
                        dangerouslySetInnerHTML={{
                          __html: (
                            props?.founderMessageData[0]?.founder_description ||
                            ""
                          ).replace(/\n/g, "<br/>"),
                        }}
                      ></div>
                    </div>
                  </Fade>
                )}
              </div>

              <div className="about-page__right">
                <p
                  className="about-page__text"
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{
                    __html: marked(
                      props?.founderMessageData[0]?.description || "",
                    ) as string,
                  }}
                ></p>
              </div>

              {/* Optional: Clear floated image */}
              {/* <div style={{ clear: "both" }}></div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderMessage;
